import palette from '@lib/core/src/theme/palette';
import { styled, Stack, Typography, IconButton, Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { USER_DETAILS_HEIGHT } from '@/components/sidebar/UserDetails';

const CARD_GAP = '1vh';
const WIDE_CARD_WIDTH = '70%';
const NARROW_CARD_WIDTH = `calc(100% - ${WIDE_CARD_WIDTH} - ${CARD_GAP})`;

const HEADER_HEIGHT = '48px';

export const Wrapper = styled(Stack)({
  width: '100%',
  height: '100%',
  backgroundImage: `radial-gradient(circle, ${alpha(palette.grey[2500], 0.2)} 2px, transparent 1px)`,
  backgroundSize: '30px 30px',
  backgroundColor: palette.globalBackground,
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 10
});

export const ScrollMarginDiv = styled('div')({
  height: USER_DETAILS_HEIGHT,
  width: '100%'
});

export const Form = styled('form')({
  width: '100%',
  height: '100%'
});

export const Header = styled(Stack)({
  width: '100%',
  flexDirection: 'row',
  height: HEADER_HEIGHT,
  alignItems: 'center'
});

export const BackButton = styled(IconButton)({
  width: '60px',
  height: '32px',
  borderRadius: '24px',
  padding: 0,
  color: palette.black
});

export const BackButtonText = styled(Typography)({
  fontSize: '13px',
  lineHeight: '32px',
  textTransform: 'none'
});

export const ScrollWrapper = styled(Stack)({
  width: '100%',
  height: '100%',
  overflow: 'auto',
  gap: CARD_GAP,
  padding: '2vh 2vw'
});

export const WideCardsWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: CARD_GAP,
  [theme.breakpoints.up('lg')]: {
    width: WIDE_CARD_WIDTH
  }
}));

export const NarrowCardsWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  gap: CARD_GAP,
  [theme.breakpoints.up('lg')]: {
    width: NARROW_CARD_WIDTH
  }
}));

export const Card = styled(Stack)({
  width: '100%',
  backgroundColor: palette.white,
  borderRadius: '16px',
  padding: '4vh 2vw',
  border: `1px solid ${palette.grey[1200]}`
});

export const CardsWrapper = styled(Stack)(({ theme }) => ({
  width: '100%',
  height: '100%',
  marginBottom: USER_DETAILS_HEIGHT,
  flexWrap: 'wrap',
  flexDirection: 'row',
  gap: CARD_GAP,
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'column'
  }
}));

export const ButtonsWrapper = styled(Stack)({
  borderTop: `1px solid ${palette.grey[1200]}`,
  backgroundColor: alpha(palette.white, 0.5),
  padding: '0 12px',
  backdropFilter: `blur(10px)`,
  position: 'absolute',
  bottom: 0,
  right: 0,
  width: '100%',
  height: USER_DETAILS_HEIGHT,
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 12
});

export const LargeTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: 16,
  marginBottom: 4,
  color: palette.black
});

export const ToggleBox = styled('div')({
  marginLeft: 'auto'
});

export const Label = styled('div')({
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 11,
  color: palette.black
});

export const HelperText = styled(Label)({
  color: palette.red[100]
});

export const Row = styled(Stack)({
  flexDirection: 'row',
  gap: 8
});
